// Polyfills for SSR

var isSSR = typeof window === 'undefined';

export var HTMLElement = isSSR ? Object : window.HTMLElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/utils/ssr.js
// module id = null
// module chunks = 